import { ConsentConfigMetaV1, CONSENT_CONFIG_V1_META_NAME } from '../model/ConsentConfigMetaV1';
import { ConsentRequestConfigMeta } from '../model/ConsentRequestConfigMeta';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const toConfigFromMetaV1 = (meta?: Record<string, any>): ConsentRequestConfigMeta => {
  const configMetaV1 = meta?.[CONSENT_CONFIG_V1_META_NAME]
    ? (meta[CONSENT_CONFIG_V1_META_NAME] as ConsentConfigMetaV1)
    : ConsentRequestConfigMeta.empty();

  return {
    ...configMetaV1,
  };
};

export { toConfigFromMetaV1 };
